export default {
  'shipping.h1': 'Koszt wysyłki USFans: kompletny przewodnik po opłatach i dostawie',
  'shipping.lead': 'Dowiedz się, jak działa wysyłka USFans, co wpływa na ostateczny koszt wysyłki i jak oszacować dostawę przed złożeniem zamówienia.',
  'shipping.category': 'Wysyłka',
  'shipping.shortTitle': 'Koszt wysyłki USFans',
  'shipping.readTime': '7 min czytania',
  'shipping.toc': 'Spis treści',

  'shipping.s1.title': 'Jak działa wysyłka',
  'shipping.s1.p1': 'USFans wysyła zamówienia z magazynu na adres podany przy kasie. Po złożeniu zamówienia produkt jest pobierany, pakowany i przekazywany przewoźnikowi, który dostarcza go zgodnie z wybraną metodą.',
  'shipping.s1.p2': 'Ponieważ zamówienia mogą różnić się rozmiarem, wagą i miejscem docelowym, koszt wysyłki jest zwykle obliczany przy kasie, a nie jako jedna stała cena dla wszystkich.',

  'shipping.s2.title': 'Co wpływa na koszt',
  'shipping.s2.p1': 'Na ostateczny koszt wysyłki wpływa kilka czynników. Miejsce docelowe jest często najważniejsze — dostawy międzynarodowe i na duże odległości zwykle kosztują więcej niż lokalne. Znaczenie ma też waga i rozmiar zamówienia, ponieważ większe lub cięższe paczki są droższe w transporcie.',
  'shipping.s2.p2': 'Wybrana metoda wysyłki również ma znaczenie. Szybsze lub śledzone opcje są zwykle droższe, podczas gdy opcje standardowe lub ekonomiczne są tańsze, ale wolniejsze.',

  'shipping.s3.title': 'Szacowanie czasu dostawy',
  'shipping.s3.p1': 'Czas dostawy zależy od miejsca docelowego, przewoźnika i metody wysyłki. Zamówienia lokalne zwykle docierają szybciej, a międzynarodowe mogą trwać dłużej ze względu na odprawę celną i odległość.',
  'shipping.s3.p2': 'Najdokładniejszym szacunkiem jest ten pokazany na stronie kasy lub produktu w momencie zamówienia. Ogólne szacunki traktuj jako wskazówkę, a nie gwarancję.',

  'shipping.s4.title': 'Typowe opcje wysyłki',
  'shipping.s4.p1': 'Większość sklepów internetowych, w tym USFans, oferuje kilka poziomów wysyłki. Wysyłka standardowa to ekonomiczny wybór, a opcje ekspresowe stawiają na szybkość. Niektóre zamówienia mogą też oferować śledzenie dla dodatkowego spokoju.',
  'shipping.s4.p2': 'Wybór odpowiedniej opcji to równowaga między kosztem a szybkością. Jeśli się nie spieszysz, wysyłka standardowa zwykle oferuje najlepszą wartość; jeśli czas ma znaczenie, szybsza metoda może być warta dopłaty.',

  'shipping.s5.title': 'Porównanie metod wysyłki',
  'shipping.s5.p1': 'Poniższa tabela porównuje typowe podejścia do wysyłki, aby pomóc Ci wybrać odpowiednie dla siebie.',
  'shipping.table.c1': 'Metoda',
  'shipping.table.c2': 'Szybkość',
  'shipping.table.c3': 'Koszt',
  'shipping.table.c4': 'Najlepsza dla',
  'shipping.table.r1c1': 'Standardowa',
  'shipping.table.r1c2': 'Wolniejsza',
  'shipping.table.r1c3': 'Najniższy',
  'shipping.table.r1c4': 'Oszczędnych kupujących',
  'shipping.table.r2c1': 'Ekspresowa',
  'shipping.table.r2c2': 'Szybka',
  'shipping.table.r2c3': 'Wyższy',
  'shipping.table.r2c4': 'Pilnych zamówień',
  'shipping.table.r3c1': 'Śledzona',
  'shipping.table.r3c2': 'Różnie',
  'shipping.table.r3c3': 'Umiarkowany',
  'shipping.table.r3c4': 'Spokoju ducha',
  'shipping.table.r4c1': 'Międzynarodowa',
  'shipping.table.r4c2': 'Najwolniejsza',
  'shipping.table.r4c3': 'Najwyższy',
  'shipping.table.r4c4': 'Kupujących z zagranicy',

  'shipping.s6.title': 'Sprawdzanie ceny końcowej',
  'shipping.s6.p1': 'Całkowity koszt zamówienia składa się z ceny produktu plus wysyłka i ewentualne opłaty. Zawsze sprawdzaj pełną sumę przy kasie przed potwierdzeniem, aby uniknąć niespodzianek.',
  'shipping.s6.p2': 'Jeśli koszt wysyłki wydaje się niejasny, podsumowanie kasy lub strona informacyjna o wysyłce to najlepsze miejsce, aby znaleźć bieżące, dokładne szczegóły.',

  'shipping.s7.title': 'Wskazówki dotyczące wysyłki',
  'shipping.s7.p1': 'Aby utrzymać rozsądne koszty, rozważ połączenie kilku produktów w jedno zamówienie, gdy to możliwe, i wybierz metodę wysyłki odpowiadającą Twoim realnym potrzebom. Planowanie z wyprzedzeniem pomoże uniknąć płacenia za szybszą wysyłkę, której nie potrzebujesz.',
  'shipping.s7.p2': 'Zawsze dokładnie sprawdzaj adres dostawy przed złożeniem zamówienia, ponieważ błędny adres może powodować opóźnienia lub dodatkowe opłaty.',

  'shipping.conclusion.title': 'Podsumowanie',
  'shipping.conclusion.p1': 'Koszt wysyłki USFans zależy od miejsca docelowego, wielkości zamówienia i wybranej metody. Rozumiejąc te czynniki, możesz oszacować dostawę i wybrać opcję najlepiej dopasowaną do budżetu i terminu.',
  'shipping.conclusion.p2': 'Aby poznać bieżące ceny i szacunki dostawy, sprawdź bezpośrednio oficjalny sklep. Zacznij od przeglądania kategorii na stronie głównej.',

  'shipping.cta': 'Sprawdź sklep USFans',
  'shipping.backHome': 'Wróć na stronę główną',
};